import { CASE_ITEM_TYPE_TRANSLATION_IDS } from 'Constants/caseItemType'

import { CaseItemType } from 'Portal/__generated__/globalTypes'

import { dashToUnderscore } from '../dashToUnderscore/dashToUnderscore.util'
import { getCaseItemTypeTranslationId } from '../getCaseItemTypeTranslationId/getCaseItemTypeTranslationId.util'

export const getOrderDisplayName = (
  caseType: `${CaseItemType}`,
  deviceName: string,
) => {
  const formattedCaseType = dashToUnderscore(caseType)

  if (
    formattedCaseType === CaseItemType.general ||
    formattedCaseType === CaseItemType.new_phone_plan
  ) {
    return CASE_ITEM_TYPE_TRANSLATION_IDS[formattedCaseType]
  }

  return {
    name: deviceName,
    type: getCaseItemTypeTranslationId(caseType),
  }
}
